export default __webpack_public_path__ + "static/media/bg.f505b2b7.mp4";